import type { AxiosRequestConfig } from "axios"

import { customMutator } from "@/networking/axios"

type TokenResponse = {
  token: string
}

export const impersonateUser = (
  userId: string,
  requestOptions?: AxiosRequestConfig
): Promise<TokenResponse> =>
  customMutator<TokenResponse>(
    { url: `/api/users/${userId}/impersonate`, method: "POST" },
    { withCredentials: true, ...requestOptions }
  )

export const exitImpersonation = (requestOptions?: AxiosRequestConfig): Promise<TokenResponse> =>
  customMutator<TokenResponse>(
    { url: "/api/impersonate/exit", method: "POST" },
    { withCredentials: true, ...requestOptions }
  )
